import { SubDataTable } from "@msuite/ui/table";
import {
	VendorArticlesMenu,
	vendorArticlesColumns,
} from "@/components/stock/vendor-articles-table";
import { useVendorArticlesList } from "@/hooks/use-vendor-articles-list";

/** Props Interface */
interface VendorArticlesProps {
	articleId: string;
}

export function VendorArticles({ articleId }: VendorArticlesProps) {
	/** Hooks */
	const { vendorArticles, isLoading, refetch, queryKey } = useVendorArticlesList(articleId);

	/** Render */
	return (
		<SubDataTable
			data={vendorArticles}
			columns={vendorArticlesColumns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<VendorArticlesMenu articleId={articleId} />}
			persistenceKey="vendor-articles-table"
		/>
	);
}
